import React from 'react';
import { FaLightbulb, FaMoon } from 'react-icons/fa';
import LanguageSwitcher from './LanguageSwitcher';
import { useTheme } from '../../context/ThemeContext';


const ColorSwitcher = () => {
    const { toggleTheme, theme } = useTheme();

    return (
        <div className="my_switcher d-none d-lg-block">
            <button onClick={toggleTheme}>
                <span className="setColor dark"><FaLightbulb /></span>
                <span className="setColor light"><FaMoon /></span>
            </button>
            <div style={{marginTop: '10px'}}>
                <LanguageSwitcher />
            </div>
        </div>
    )
}

export default ColorSwitcher;